import { useMemo } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import PlatformSidebar from '../components/PlatformSidebar';
import BreadcrumbBar from '../components/BreadcrumbBar';
import WorkspaceFrame from '../components/WorkspaceFrame';

const PAGE_TITLES = {
  '/platform': 'Companies',
  '/platform/invitations': 'Invitation requests',
};

export default function PlatformShell() {
  const navigate = useNavigate();
  const location = useLocation();
  const pageTitle = PAGE_TITLES[location.pathname] || 'Platform console';

  const segments = useMemo(() => {
    if (location.pathname === '/platform') {
      return [{ label: 'Platform console', current: true }];
    }
    return [
      { label: 'Platform console', onClick: () => navigate('/platform') },
      { label: pageTitle, current: true },
    ];
  }, [location.pathname, navigate, pageTitle]);

  return (
    <div className="screen active">
      <PlatformSidebar />
      <div className="main">
        <BreadcrumbBar segments={segments} />
        <WorkspaceFrame rexBase={{ layer: 'platform-console', orgName: 'Platform console' }}>
          <Outlet />
        </WorkspaceFrame>
      </div>
    </div>
  );
}
